import React from 'react';
import { Button } from 'reactstrap';

interface Props {
  text: string;
  maxLength?: number;
  onReadMore?: () => void;
}

const ReadMoreText: React.FC<Props> = ({ text = '', maxLength = 100, onReadMore }) => {
  const shortText = text.length > maxLength ? text.substring(0, maxLength).replace(/\s+\S*$/, '') : text;

  return (
    <span className="read-more-text">
      {shortText}
      {text.length > maxLength && (
        <>
          ...{' '}
          <Button color="link" className="p-0 read-more-btn" onClick={onReadMore}>
            Read more
          </Button>
        </>
      )}
    </span>
  );
};

export default ReadMoreText;
